module.exports = __webpack_public_path__ + "img/21.ff629043.jpg";